<template>
  <div class="wrap">
    <Header></Header>

    <!--顶部广告-->
    <div v-if="dingbu1.logo">
      <a class="guanggao" :href="dingbu1.dirlink" v-if="dingbu1.type&&dingbu1.type===1">
        <object data type>
          <embed class="guanggao-img" :src="dingbu1.logo" type>
        </object>
      </a>
      <a class="guanggao" :href="dingbu1.dirlink" v-else>
        <img style="width:1200px;height:100px" class="guanggao-img" :src="dingbu1.logo" alt>
      </a>
    </div>

    <div class="content-wrap">
      <div class="content-left">
        <div class="seat">
          <span>当前位置：</span>
          <router-link to="/">首页></router-link>
          <span class="coord" v-if="cate" v-text="cate+'>'" @click="$router.go(-1)"></span>
          <span class="coord">详情</span>
        </div>

        <div class="news-content">
          <span class="title" v-text="complainMessage.title"></span>
          <div class="from">
            <span v-text="'发布时间：'+complainMessage.create_time"></span>
          </div>
          <div class="complain-wrap">
            <div class="info-block">
              <div class="info-title">投诉人情况</div>
              <div class="info-wrap">
                投诉时间：
                <span>{{complainMessage.create_time}}</span>
              </div>
              <div class="info-wrap">
                投诉人姓名：
                <span>{{complainMessage.c_realname}}</span>
              </div>
              <div class="info-wrap">
                投诉人电话：
                <span>{{complainMessage.c_address}}</span>
              </div>
              <div class="info-wrap">
                投诉人地址：
                <span>{{complainMessage.g_address}}</span>
              </div>
              <div class="info-wrap">
                投诉人邮箱：
                <span>{{complainMessage.c_email}}</span>
              </div>
            </div>
            <div class="info-block">
              <div class="info-title">被投诉方信息</div>
              <div class="info-wrap">
                被投诉方名称：
                <span>{{complainMessage.g_realname}}</span>
              </div>
              <div class="info-wrap">
                被投诉方统一社会信用代码：
                <span>{{complainMessage.credit_code}}</span>
              </div>
              <div class="info-wrap">
                被投诉方地址：
                <span>{{complainMessage.g_address}}</span>
              </div>
              <div class="info-wrap">
                被投诉方联系人：
                <span>{{complainMessage.g_contact}}</span>
              </div>
              <div class="info-wrap">
                被投诉方电话：
                <span>{{complainMessage.g_mobile}}</span>
              </div>
            </div>
            <div class="info-block">
              <div class="info-title">投诉内容</div>
              <div class="info-wrap">
                投诉地区：
                <span>{{complainMessage.area}}</span>
              </div>
              <div class="info-wrap">
                投诉类别：
                <span v-text="complainMessage.type_title"></span>
              </div>
              <div class="info-wrap">
                投诉内容标题：
                <span>{{complainMessage.title}}</span>
              </div>
              <div class="info-wrap">
                <div>投诉内容描述：</div>
                <span
                  style="display:inline-block;margin-left: 30px;height:30px; line-height:30px;"
                >{{complainMessage.detail}}</span>
              </div>
              <div class="info-wrap">
                <div>投诉要求：</div>
                <span
                  style="display:inline-block;margin-left:30px;height:30px; line-height:30px;"
                >{{complainMessage.demand}}</span>
              </div>
            </div>

            <div class="info-block">
              <div class="info-title">投诉证据</div>
              <!--如果图片证据存在-->
              <div v-if="complainData.images[0]!==''">
                <div class="info-wrap">证据图片：</div>
                <div v-for="(item,index) in complainData.images" :key="index">
                  <img class="info-img" v-if="item.dir" :src="item.dir" alt="证据图片">
                  <span class="not-img" v-else>暂无图片证据</span>
                </div>
              </div>
              <!--证据录音-->
              <div>
                <span style="color:#afafaf">证据录音：</span>
                <div class="voices" v-for="(item,index) in voices" :key="index" v-show="item.dir">
                  <audio controls>
                    <source :src="item.dir" type="audio/mpeg">您的浏览器不支持 audio 元素。
                  </audio>
                </div>
              </div>
              <div class="video">
                <span style="color:#afafaf">证据视频：</span>
                <div class="voices" v-for="(item,index) in videos" :key="index" v-show="item.dir">
                  <video :src="item.dir" controls="controls">您的浏览器不支持 video 标签。</video>
                </div>
              </div>
            </div>
            <div class="wechat-img-box" v-if="bottom_image">
              <img class="wechat-img" :src="bottom_image" alt="微信公众号">
            </div>
          </div>
        </div>

        <!--分享链接-->
        <div class="pinglun">
          <div style="color:#999;">分享到：</div>
          <other-share ref="share"></other-share>
        </div>

        <!--评论区-->

        <div class="content-foot">
          <div class="comment-wrap">
            <div class="comment-number">
              <span class="number" v-text="commentNumber||0"></span>条评论
            </div>
            <div class="input-wrap">
              <textarea class="comment" type="text" placeholder="写下您的评论" v-model="commentInfo"/>
              <button class="releace" type="submit" @click="upComment">发布</button>
            </div>

            <hr>
            <!--评论详情-->
            <div class="comment-area" v-for="(item,index) in commentMsg" :key="index">
              <div class="comment-title">
                <div>
                  <span v-text="item.nickname"></span>
                  <!--用户名-->
                  <span v-if="item.is_top!==0" class="top">置顶</span>
                </div>
                <span v-text="item.create_time"></span>
              </div>
              <div class="comment-info" v-text="item.detail"></div>
              <hr>
            </div>

            <div class="more-comment" @click="moreComment">更多评论></div>
          </div>
        </div>
      </div>

      <div class="content-right">
        <div style="margin-left:50px;">
          <Ranking :type="1" title="投诉榜" :list="leader_board"></Ranking>
        </div>
        <div style="margin-left:50px;">
          <Ranking :type="2" title="和解榜" :list="peace"></Ranking>
        </div>
        <div>
          <a
            style="margin-left:50px;"
            class="guanggao2"
            :href="art3.dirlink"
            target="_blank"
            v-if="art3.type&&art3.type===1"
          >
            <object data type>
              <embed :src="art3.logo" type style="width:790px;height:100px;">
            </object>
          </a>
          <a style="margin-left:50px;" class="guanggao2" :href="art3.dirlink" v-else>
            <img :src="art3.logo" alt>
          </a>
        </div>

        <a
          style="margin-left:50px;"
          class="guanggao2"
          :href="art2.dirlink"
          target="_blank"
          v-if="art2.type&&art2.type===1"
        >
          <object data type>
            <embed :src="art2.logo" type style=" width:380px;height:100px;">
          </object>
        </a>
        <a style="margin-left:50px;" class="guanggao2" :href="art2.dirlink" v-else>
          <img :src="art2.logo" alt style="width:380px;height:100px">
        </a>
      </div>
    </div>
    <HomeFoot></HomeFoot>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HomeFoot from "@/components/HomeFoot.vue";
import CommentRank from "@/components/CommentRank.vue";
import Ranking from "@/components/Ranking.vue";
import OtherShare from "@/components/OtherShare.vue";

export default {
  name: "complainInfo",
  components: {
    Header,
    HomeFoot,
    CommentRank,
    Ranking,
    OtherShare
  },
  data() {
    return {
      id: "",
      complainData: "",
      complainMessage: "",
      rightNews: "",
      cate: "", //新闻所属类别
      commentInfo: "", //提交评论内容
      commentPage: 1,
      commentMsg: "", //获取的评论内容
      morePinglun: "",
      leader_board: "",
      peace: "",
      commentNumber: "",
      dingbu1: "",
      art2: "",
      art3: "",
      voices: "",
      videos: "",
      bottom_image: '',
      totalPage: "",
      shareData: {
        url: "",
        title: "",
        pic: "",
        desc: ""
      },
      loading: false
    };
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.getNewsContent();
    }
  },
  created() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.getNewsContent();
    this.getRightNews();
    this.getCrunchies();
    this.getGuangGao();
    this.readComment();
  },
  mounted() {
    setTimeout(() => {
      this.getOtherShare();
    }, 20);
  },
  methods: {
    getNewsContent() {
      // 获取首页跳转时携带的分类id
      this.id = this.$route.query.id;
      this.cate = this.$route.query.cate;
      this.$post("https://315sd.0532.name/api/general/detail", {
        id: this.id
      })
        .then(res => {
          if (res.code === 0) {
            this.complainData = res.data;
            this.bottom_image = res.data.bottom_image;
            this.complainMessage = res.data.info;
            this.shareConfig.title = res.data.info.title;
            this.voices = res.data.voices;
            this.videos = res.data.videos;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //右侧模块新闻
    getCrunchies() {
      this.$get("/index/index/center_article")
        .then(res => {
          if (res.code === 0) {
            this.leader_board = res.data.leader_board;
            this.peace = res.data.peace;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取右侧新闻模块数据
    getRightNews() {
      // 获取首页跳转时携带的分类id
      this.id = this.$route.query.id;
      this.$get("https://315sd.0532.name/api/general/new_hot")
        .then(res => {
          if (res.code === 0) {
            this.rightNews = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 提交评论
    upComment() {
      if (this.loading) return
      this.loading = true
      if (this.commentInfo) {
        let token = localStorage.getItem("token");
        this.$post("/index/comment/ppost_comment", {
          order_id: this.$route.query.id,
          token: token,
          detail: this.commentInfo
        })
          .then(res => {
            this.loading = false
            if (res.code === 0) {
              this.$message({
                message: res.msg,
                type: "success"
              });
              this.commentInfo = ""; //提交评论清空评论框
              this.readComment();
            }
          })
          .catch(err => {
            this.loading = false
            console.log(err);
          });
      } else {
        this.loading = false
        this.$message({
          message: "请输入评论",
          type: "success"
        });
      }
    },
    //加载评论
    readComment() {
      this.$post("https://315sd.0532.name/index/comment/comment_list", {
        id: this.$route.query.id, //文章ID
        page: this.commentPage
      })
        .then(res => {
          if (res.code === 0) {
            this.totalPage = res.data;
            this.commentNumber = res.data.count;
            this.commentMsg = res.data.listData;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取更多评论
    moreComment() {
      this.commentPage++;
      if (this.commentPage > this.totalPage) {
        this.$message("没有更多评论了");
      } else {
        this.$post("https://315sd.0532.name/index/comment/comment_list", {
          id: this.$route.query.id,
          page: this.commentPage
        })
          .then(res => {
            if (res.code === 0) {
              this.morePinglun = res.data.listData;
              // 将新添加的评论添加到commentMsg并且原来的评论不会被覆盖
              if (!this.morePinglun[0]) {
                this.$message("没有更多评论了");
              } else {
                this.commentMsg.push.apply(this.commentMsg, this.morePinglun);
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    getGuangGao() {
      this.$get("https://315sd.0532.name/index/index/complaint_list_ad")
        .then(res => {
          if (res.code === 0) {
            this.dingbu1 = res.data.ad1;
            this.art2 = res.data.ad2;
            this.art3 = res.data.ad3;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 分享
    getOtherShare() {
      // 获取分享参数
      let params = {
        type: 2,
        id: this.$route.query.id,
        url: window.location.href.split("#")[0]
      };
      this.$post("/index/mobile/share_other", params).then(res => {
        if (res.code === 0) {
          this.shareData.url = window.location.href;
          this.shareData.title = res.data.share.title;
          this.shareData.pic = res.data.share.imgUrl;
          this.shareData.desc = res.data.share.desc;
          this.$refs.share.init(this.shareData);
        } else {
          this.$layer.toast(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.voices {
  margin-top: 20px;
}

.video {
  margin-top: 20px;
}

.guanggao {
  display: block;
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  margin-top: 20px;

  img {
    width: 1200px;
    height: 100px;
  }
}

.guanggao2 {
  display: block;
  width: 380px;
  height: 100px;
  margin: 10px 0;

  img {
    width: 380px;
    height: 100px;
  }
}

.top {
  width: 27px;
  height: 13px;
  background: #d60106;
  font-size: 8px;
  font-family: MicrosoftYaHei;
  color: rgba(255, 255, 255, 1);
  line-height: 10px;
  padding: 1px 2px;
  margin-left: 3px;
}

.info-block {
}

.info-wrap {
  margin: 8px 0;
  font-size: 16px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 22px;

  span {
    color: rgba(51, 51, 51, 1);
  }
}

.info-title {
  border-left: 4px solid #335485;
  padding-left: 5px;
  margin: 16px 0;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  line-height: 25px;
}

.info-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.wechat-img-box{
  margin-top: 40px;
}

.wechat-img {
  max-width: 726px;
  height: 530px;
}

.content-wrap {
  display: flex;
  width: 1200px;
  margin: 32px auto;
  justify-content: space-between;
}

.coord {
  color: #000000;
  cursor: pointer;
}

.content-left {
  width: 780px;

  .seat {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
    margin-bottom: 40px;

    .seat > span {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
    }
  }
}

.title {
  font-size: 38px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: #666666;
  line-height: 59px;
  display: inline-block;
  width: 750px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.from {
  height: 21px;
  font-size: 17px;
  font-family: MicrosoftYaHei;
  color: rgba(102, 102, 102, 1);
  line-height: 21px;
  margin-bottom: 33px;
  margin-top: 15px;
}

.from > span {
  margin-left: 40px;
}

.from > span:first-child {
  margin-left: 0;
}

.text {
  width: 780px;
  height: 810px;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}

.text > img {
  max-width: 100%;
}

.content-foot {
  display: flex;
  justify-content: space-between;
  width: 787px;
  margin-top: 46px;
}

.comment-wrap {
  width: 787px;
}

.comment-wrap > hr {
  margin-top: 30px;
  border: 0;
  height: 1px;
  background: #d8d8d8;
}

.pinglun {
  display: flex;
  align-items: center;
  margin-top: 40px;
}

.input-wrap {
  width: 787px;
  overflow: hidden;

  .releace {
    float: right;
    margin-top: 20px;
    padding: 10px 30px;
    background: #294b7f;
    outline: none;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #fff;
    cursor: pointer;
    border-radius: 3px;
  }
}

.comment {
  width: 100%;
  box-sizing: border-box;
  min-height: 76px;
  outline: none;
  -webkit-appearance: none;
  border-radius: 0;
  border: 1px solid #979797;
  line-height: 28px;
  padding: 10px 0;
  font-size: 16px;
  /*border-right: none;*/
  padding-left: 8px;
}

.comment:empty::before {
  color: lightgrey;
  content: attr(placeholder);
}

.content-right {
  margin-top: 60px;
}

.content-right > div {
  margin-bottom: 20px;
}

.comment-area {
  width: 787px;
  margin-top: 19px;
}

.comment-area > hr {
  border: 0;
  height: 1px;
  background: #d8d8d8;
}

.comment-number {
  color: #a8a8a8;
}

.number {
  height: 29px;
  font-size: 22px;
  font-family: MicrosoftYaHei;
  color: rgba(208, 2, 27, 1);
  line-height: 29px;
}

.comment-title {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #6b6b6b;
  line-height: 21px;
}

.comment-info {
  width: 780px;
  word-wrap: break-word;
  margin: 16px 0;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: #333333;
  line-height: 21px;
}

.more-comment {
  width: 95px;
  height: 30px;
  background: #f3f3f3;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: rgba(102, 102, 102, 1);
  line-height: 30px;
  text-align: center;
  margin-left: 332px;
  margin-top: 30px;
  cursor: pointer;
}
</style>
